var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { transient, autoinject } from 'aurelia-dependency-injection';
import { BasePurchases } from '../../base-purchases';
import { BrandingBase } from '../../../../../views/app/admin/branding/branding-base';
import { Router } from 'aurelia-router';
import { EventAggregator } from 'aurelia-event-aggregator';
import { ClientLotteryClientService } from '../../../../../services/modules/client/client-lottery-client-service';
import { ClientHotLotteriesClientService } from '../../../../../services/modules/client/client-hot-lotteries-client.service';
import { NotificationClientService } from '../../../../../services/basics/notification-client.service';
import { I18N } from 'aurelia-i18n';
import { TokenClient } from '../../../../../services/authentication/token-client.service';
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
var Purchases = /** @class */ (function (_super) {
    __extends(Purchases, _super);
    function Purchases(router, lotteryClientService, eventAggregator, hotLotteryClientService, notificationClientService, i18N, tokenClient, dialogClient) {
        return _super.call(this, router, lotteryClientService, eventAggregator, hotLotteryClientService, notificationClientService, tokenClient, i18N, dialogClient) || this;
    }
    Purchases.prototype.attached = function () {
        _super.prototype.attached.call(this);
    };
    Purchases.prototype.detached = function () {
        _super.prototype.detached.call(this);
    };
    Purchases.prototype.termsAndConditions = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Images
                //Text
                //Colors
                "terms-and-conditions-foreground"
            ]
        }, window.parent.location.origin);
    };
    Purchases.prototype.showPurchases = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "lotteries-purchases-title",
                "lotteries-purchases-lottery-purchase-date",
                "lotteries-purchases-lottery-draw-date",
                "lotteries-purchases-lottery-win-value-credited-date",
                "lotteries-purchases-lottery-draw-results",
                "lotteries-purchases-lottery-client-name",
                "lotteries-purchases-lottery-client-email",
                "lotteries-purchases-lottery-client-phone",
                "lotteries-purchases-lottery-status",
                "Won",
                "Lost",
                "Pending",
                "lotteries-purchases-lottery-view-tickets",
                "lotteries-purchases-lottery-hide-tickets",
                "lotteries-purchases-lottery-fallback",
                "lotteries-purchases-lottery-button-load-more",
                "lotteries-lottery-secure-transaction-title",
                "lotteries-lottery-secure-transaction-desc",
                //Colors
                "lotteries-title",
                "lotteries-lottery-background",
                "lotteries-lottery-name-foreground",
                "lotteries-lottery-label-foreground",
                "lotteries-lottery-status-foreground",
                "lotteries-lottery-number-background",
                "lotteries-lottery-tickets-details-background",
                "lotteries-lottery-tickets-details-border",
                "lotteries-lottery-tickets-ticket-label-foreground",
                "lotteries-lottery-tickets-ticket-border",
                "lotteries-lottery-tickets-ticket-number-border",
                "lotteries-lottery-tickets-ticket-number-background",
                "lotteries-lottery-tickets-ticket-number-foreground",
                "lotteries-lottery-tickets-ticket-number-bonus-background",
                "lotteries-lottery-tickets-ticket-number-bonus-foreground",
                "lotteries-lottery-tickets-ticket-status-pending",
                "lotteries-lottery-tickets-ticket-status-nowin",
                "lotteries-lottery-tickets-ticket-status-winner",
                "lotteries-lottery-tickets-ticket-button-foreground",
                "lotteries-lottery-tickets-ticket-button-hover-foreground",
                "lotteries-lottery-tickets-ticket-button-background",
                "lotteries-lottery-tickets-ticket-button-hover-background",
                "lotteries-lottery-secure-transaction-background",
                "lotteries-button-load-more-foreground"
            ]
        }, window.parent.location.origin);
    };
    Purchases.prototype.showHottestLotteries = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "hottest-lotteries-title",
                "hottest-lotteries-remaning-time",
                "hottest-lotteries-remaning-days",
                "hottest-lotteries-remaning-hours",
                "hottest-lotteries-remaning-minutes",
                "hottest-lotteries-button",
                //Colors
                "hottest-lotteries-title-foreground",
                "hottest-lotteries-background",
                "hottest-lotteries-details-foreground",
                "hottest-lotteries-details-digits-background",
                "hottest-lotteries-details-digits-foreground",
                "hottest-lotteries-prize-currency-foreground",
                "hottest-lotteries-prize-amount-foreground",
                "hottest-lotteries-prize-button-background",
                "hottest-lotteries-prize-button-foreground"
            ]
        }, window.parent.location.origin);
    };
    Purchases = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [Router, ClientLotteryClientService, EventAggregator,
            ClientHotLotteriesClientService, NotificationClientService,
            I18N, TokenClient, DialogClientService])
    ], Purchases);
    return Purchases;
}(BasePurchases));
export { Purchases };
